/** @jsx jsx */
// @ts-check
import { Flex as BaseFlex, jsx } from 'theme-ui';
/**
 *
 * @param {object} props
 * @param {'row'|'column'|'row-reverse'|'column-reverse'|any} [props.direction] The flex-direction CSS attribute.
 * @param {'wrap'|'wrap-reverse'|'nowrap'|any} [props.wrap] The flex-wrap CSS attribute.
 * @param {'wrap'|any} [props.justify] The justify-content CSS attribute.
 * @param {'wrap'|any} [props.align] The align-items CSS attribute.
 * @param {boolean} [props.inline] Makes this an inline flex box.
 * @param {number|string} [props.gap] The gap between children. This is simulated via CSS.
 * @param {import('react').ReactNode} [props.children]
 * @param {*} [props.rest]
 */
export default function Flex({
  direction,
  wrap,
  gap,
  justify,
  align,
  inline,
  children,
  ...rest
}) {
  return (
    <BaseFlex
      sx={{
        display: inline ? 'inline-flex' : 'flex',
        flexDirection: direction,
        flexWrap: wrap,
        justifyContent: justify,
        alignItems: align,
        gap: gap,
        // A "polyfill" for the missing flex-gap property.
        '> :not(:last-child)': gap
          ? direction?.includes('column')
            ? direction?.includes('reverse')
              ? { marginTop: gap }
              : { marginBottom: gap }
            : direction?.includes('reverse')
            ? { marginLeft: gap }
            : { marginRight: gap }
          : undefined,
      }}
      {...rest}
    >
      {children}
    </BaseFlex>
  );
}
